export default "__VITE_ASSET__DBmNJK6W__"